// SocialActions 유틸리티 함수
/**
 * 숫자 서식화 함수
 * @param num - 서식화할 숫자
 * @returns 서식화된 문자열 (예: 1500 -> "1.5K")
 */ export var formatNumber = function() {
    var num = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 0;
    if (num === 0) return '';
    if (num < 1000) return num.toString();
    else if (num < 1000000) return "".concat((num / 1000).toFixed(1).replace(/\.0$/, ''), "K");
    else return "".concat((num / 1000000).toFixed(1).replace(/\.0$/, ''), "M");
};
/**
 * ID 유효성 검사 헬퍼 함수
 * @param id - 검사할 ID
 * @returns 유효한 ID인지 여부
 */ export var validateId = function(id) {
    if (!id || typeof id !== 'string' || id.trim() === '') {
        console.error('[SocialActions] 오류: 유효하지 않은 ID', {
            id: id
        });
        return false;
    }
    return true;
};
/**
 * 크기에 따른 버튼 크기 설정
 */ export var getButtonSize = function(size) {
    var buttonSize = {
        sm: "xs",
        md: "sm",
        lg: "md"
    };
    return buttonSize[size];
};
